var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17.004,
    viewBox: "0 0 24 17.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#001f4c;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1008 -340)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1030.5,345.5l-11,5-11-5,11-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1026.5,347.5v7.227a14.7,14.7,0,0,1-14,0V347.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 9,
    transform: "translate(1030.5 345.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1029.5 354.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassIcon);
export default __webpack_public_path__ + "static/media/class-icon.8c9a073e4abe6ab4e7f93056c88e15a0.svg";
export { ForwardRef as ReactComponent };